import { render, staticRenderFns } from "./CustomerMenu.vue?vue&type=template&id=e643185c"
import script from "./CustomerMenu.vue?vue&type=script&lang=js"
export * from "./CustomerMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports